import React, { useState } from "react";
import Rating from "../Rating/Rating";
import styles from "../QuestionBox/QuestionBoxStyles.module.css";
import moment from "moment";
import {
  convertEpochToTimestamp,
  handlePauseAllVideo,
  replaceContentEditableText,
} from "../../utils";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import "./AnswerCardStyles.css";
import CarouselImage from "../Carousel/Carousel";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InView } from "react-intersection-observer";
import { updateViewCount } from "../../API/api";
import { useLocation } from "react-router-dom";
import FeedbackWindow from '../FeedbackWindow/FeedbackWindow';
import Voting from '../Rating/voting';
import { Button } from "@mui/material";
import { CURRENT_ROLE } from "../../API/url";
import CurationButtons from "../CurationBottons/CurationButtons";
import { curationStatus } from "../../Constants";
import styles2 from "./NewCardStyles.module.css";

export default function NewAnswerCard({ answer, question }) {
  const currentPath = useLocation();
  const [isShowOrig, setShowOrig] = useState(false);
  if (question.docType === undefined) {
    answer.expert = {};
    answer.expert.firstName = answer.expertFirstName;
    answer.expert.lastName = answer.expertLastName;
    answer.answerText = answer.answer;
    answer.expert.userUuidStr = answer.expertUuid;
  }
  if(currentPath.pathname.includes('editor') && answer.expert === null){
    answer.expert = {};
    answer.expert.firstName = 'Vizerto';
    answer.expert.lastName = 'Bot';
    answer.expert.userUuidStr = '';
  }
  if (question.origQuestionUuid === undefined) {
    question.origQuestionUuid = question.questionUuid;
  }
  if (answer.origAnswerUuid === undefined) {
    answer.origAnswerUuid =
      answer.originalAnswerUuid === undefined
        ? answer.answerUuid
        : answer.originalAnswerUuid;
  }
  if (answer.curationCategory === undefined) {
    answer.curationCategory = null;
  }
  if (answer.answerUpdatedTimestamp !== undefined) {
    answer.lastUpdatedTimestamp = answer.answerUpdatedTimestamp;
  }
  const dispatch = useDispatch();
  const modalName = useSelector((state) => state.domain.modalName);
  const { advanceFilterModalToggle, getSelectedAnswer, getSelectedQuestion, answerUuidSentToUpdateViewCount, allScrolledAnswerUuid,getSeekerAttachmentsForTrending,getSeekerAttachmentsForAnswered } =
    bindActionCreators(Actions, dispatch);
  const randomNumber = Math.random()*10;
  const searchState = useSelector((state) => state.search);
  const expertAnsweredState = useSelector((state) => state.answeredQuestions);
  const domainState = useSelector((state) => state.domain.ratings);
  const isRatingDone = useSelector((state) => state.domain.isRatingLoad);

  const inlineImageState = useSelector((state) => state.domain);
  const trendingState = useSelector((state) => state.trending);
  const [isShowReply, setIsShowReply] = useState(false);
  const addInlineImagesToAnswer = () => {
    answer.answerText = answer.answerText.replaceAll(
      '<video ',
      `<video  width="80%" height="400" id=${question.questionUuid}_${randomNumber}`
    );
    answer.answerText = answer.answerText.replaceAll(
      '<img ',
      "<img style='max-width:50%'"
    );
    if (
      inlineImageState.inlineImagesList &&
      inlineImageState.inlineImagesList.length > 0
    ) {
      for (let i = 0; i < inlineImageState.inlineImagesList.length; ++i) {
        if (inlineImageState.inlineImagesList[i].includes(".png")) {
          let replacedContent = `[content|${
            inlineImageState.inlineImagesList[i].split(".")[0]
          }|]`;
          let imgTag = `<img style='max-width:50%' src=${
            inlineImageState.inlineImagesData[
              inlineImageState.inlineImagesList[i]
            ]
          }></img>`;
          if (answer.answerText.includes(replacedContent)) {
            answer.answerText = answer.answerText.replaceAll(
              replacedContent,
              imgTag
            );
          }
        }
      }
    }
  };
  const onChangeReplyBox = () => {
    setIsShowReply(!isShowReply);
  };
  addInlineImagesToAnswer();
  const [answerRating, setAnswerRating] = useState(
    searchState.answerRating && searchState
  );

  const [isExpand, setIsExpand] = useState(false);
  const [showHideVideo, setShowHideVideo] = useState(false);
  const userState = useSelector((state) => state.user);
  const toggleShowVideoButton = () => {
    setShowHideVideo(!showHideVideo);
  };
  const onChangeExpand = (flag) => {
    setIsExpand(flag);
  };
  const extractProfilePicFromStore = () => {
    let imgData = undefined;
    if(!currentPath.pathname.includes('editor')){
      if (answer.expertImage !== undefined) {
        imgData = searchState.usersProfilePicData.find(
          (obj) => obj.uuid === answer.expertImage.uuid
        );
      } else {
        imgData = searchState.usersProfilePicData.find(
          (obj) => obj.uuid === answer.expertUuid
        );
      }
      if (imgData !== undefined) {
        let userPic = `data:image/JPEG;base64,${imgData.img}`;
        return userPic;
      } else {
        return "";
      }
    }else{
      return "";
    }
  };

  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(answer);
    getSelectedQuestion(question);
    if(question.seekerAttachments)
    {
      getSeekerAttachmentsForTrending(question.seekerAttachments)
    }
  };

  const onClickFU = () => {
    advanceFilterModalToggle({ bool: true, value: "followup2" });
    getSelectedAnswer(answer);
    getSelectedQuestion(question);
    if(question.seekerAttachments)
    {
      getSeekerAttachmentsForAnswered(question.seekerAttachments)
    }
  };

  const renderTooltipAnsweredBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Most Answered Badge
    </Tooltip>
  );

  const renderTooltipViewCount = (props) => (
    <Tooltip id="button-tooltip" style={{ fontSize: "8px" }} {...props}>
      Number of times this answer was viewed
    </Tooltip>
  );
  const renderTooltipQualityBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Quality Answered Badge
    </Tooltip>
  );

  const renderTooltipAmplifiedBadge = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Amplified Answered Badge
    </Tooltip>
  );

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };

  const helpfulAPIPayload = {
    questionUuid: question.questionUuidCopy,
    answerUuid: answer.answerUuid,
    status: "accepted",
    questionText: searchState.inputValue,
    answerText: answer.answerCopy,
    botQuestionText: question.question,
    pdfId: "",
  };
  const getAnswerUuidsForViewCountUpdation =(flag, answer, question)=>{
    if( flag  && (currentPath.pathname.includes('/trending')|| currentPath.pathname.includes('/tagdata'))){
      if(!trendingState.AllScrolledAnswerUuid.includes(answer.docId?answer.docId:answer.answerUuid)){
        let payload ={
          answerIds:answer.docId?[]:answer.answerUuid.split(),
          docIds:answer.docId?answer.docId.split():[]
        }
        let ar = trendingState.AllScrolledAnswerUuid;
        ar.push(answer.vizAnswer?answer.docId:answer.answerUuid)
        allScrolledAnswerUuid(ar);
        updateViewCount(payload, answerUuidSentToUpdateViewCount)
    }
    }
    if(flag  && currentPath.pathname.includes('/search')){
      if(!trendingState.AllScrolledAnswerUuid.includes(answer.origAnswerUuid)){
        let payload ={
          answerIds:answer.origAnswerUuid===null?answer.answerUuid.split():answer.origAnswerUuid.split(),
          docIds:[]
        }
        let ar = trendingState.AllScrolledAnswerUuid;
        ar.push(answer.origAnswerUuid)
        allScrolledAnswerUuid(ar);
        updateViewCount(payload, answerUuidSentToUpdateViewCount)
    }
    }
  }
  const stopPlayVideo = (id, key) =>{
    setTimeout(() => {
      if(key==='pause'){
        document.getElementById(id).pause();
      }
    }, 500);
  }
  const state = useSelector((state) => state?.user);
  const location = useLocation();
  // console.log("use Location",location.pathname)
  // const isId4Present = data.some(item => item.id === 4);
  const check = state?.roles
    ?.filter((item) => item.roleName === "Seeker")
    .map((item) => {
      let val = item?.permissions;
      return val.some(item => item.id === 9);
    });

  const isDisabled =check[0]===true ? false : true ;



  return (
    <InView as="div" onChange={(inView, entry) => getAnswerUuidsForViewCountUpdation(inView,answer,question)}>
      <div className="col-md-12">
      <div className={styles.answerDiv}>
        <div className={styles.expertInfo}>
          {/* {answer.expert.lastName !== 'Bot' && <img
            className="rounded-circle"
            alt="40x40"
            src={
              extractProfilePicFromStore() ||
              require("../../Images/cliente.png")
            }
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>} */}
          {/* {answer.expert.lastName === 'Bot' && <img
            className="rounded-circle"
            alt="40x40"
            src={require("../../Images/bot-icon.png")}
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>} */}
          {/* <div className="row">
            <div className={styles.userInfo}>
              <span className={styles.userName}>
                {answer.expert.firstName} {answer.expert.lastName !== 'Bot' && answer.expert.lastName}
                {answer.expert.lastName !== 'Bot' && answer.badges && answer.badges.length > 0 && (
                  <span
                    className="ms-2"
                    style={{ fontSize: "13px", cursor: "pointer" }}
                  >
                    {answer.badges.map((badge) => {
                      if (badge.name === "answered") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAnsweredBadge}
                          >
                            <span>🏅&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "quality") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipQualityBadge}
                          >
                            <span>🌟&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "amplified") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAmplifiedBadge}
                          >
                            <span>🏆&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                    })}
                  </span>
                )}
                {answer.expertScore && (
                  <span className="expScore">
                    <i className="fa fa-star" style={{ color: "#b4c6cc" }}></i>{" "}
                    {Math.round(answer.expertScore)}
                    <span style={{ color: "#949494" }}>/10</span>
                  </span>
                )}
              </span>
              {currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === '' && <span className={styles.viewScore}
                  style={{
                    float: "right",
                    marginRight:'-12px',
                    color:`${answer.curationStatus ==='pending'?'grey':'green'}`
                  }}>
              <svg width="18px" height="18px" viewBox="0 0 16 16" class="bi bi-bookmark-check-fill" fill="currentColor">
								<path fill-rule="evenodd" d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"></path>
							</svg>
              </span>}
              {answer.curationCategory && userState.geoAttributes.userId === answer.expertUuid && currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === 'pending' && <span className={styles.viewScore}
                  style={{
                    float: "right",                   
                  }}>
                    <span style={{
                    borderRadius:'3px',
                    backgroundColor:`${answer.curationCategory === 1 ? 'red':answer.curationCategory === 2 ? 'orange':'green'}`,
                    color:'#fff',
                    fontSize:'10px',
                    padding:'4px',
                    fontWeight:'600',
                  }}>
                    Needs Curation - {curationStatus[answer.curationCategory-1]}
                    </span>
              </span>}
              {answer.internal && (
                <span
                className={styles.viewScore}
                  style={{
                    float: "right",
                  }}
                >
                  <i className="fa fa-user-times"></i>&nbsp;Internal Only
                </span>
              )}
              {answer.privacy && (
                <span
                className={styles.viewScore}
                  style={{
                    float: "right",
                  }}
                >
                  <i className="fa fa-lock"></i>&nbsp;Private Only
                </span>
              )}
            </div>
          </div> */}
          {/* <div className="row">
            {answer.answeredTimestamp === answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>
                  {question.status === "accepted" ? "Viewed" : "Answered"}
                </span>
                <span className="datestamp">
                  {momentit(question.status === "accepted" ? question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp :answer.answeredTimestamp)}
                </span>
              </div>
            )}
            {answer.answeredTimestamp < answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>{question.status === "accepted" ? "Viewed" : "Last reviewed"}</span>
                <span className="datestamp">
                  {momentit(question.status === "accepted"?question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp:answer.lastUpdatedTimestamp)}
                </span>
              </div>
            )}
          </div> */}
          <div className={styles2.newContainer}>
            <div className={styles2.subcontainerLeft}>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap', alignItems:'center'}}>
            <div>
            {answer.expert.lastName !== 'Bot' && <img
            className="rounded-circle"
            alt="40x40"
            src={
              extractProfilePicFromStore() ||
              require("../../Images/cliente.png")
            }
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>}
          {answer.expert.lastName === 'Bot' && <img
            className="rounded-circle"
            alt="40x40"
            src={require("../../Images/bot-icon.png")}
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>}
            </div>
          <div style={{marginLeft:'5px', fontSize:'14px', fontWeight:'500'}}><p style={{marginBottom:'0px'}}>{answer.expert.firstName}</p><p style={{marginBottom:'0px'}}>{answer.expert.lastName !== 'Bot' && answer.expert.lastName}</p></div>
            </div>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap'}}>
            <div>
            {answer.expert.lastName !== 'Bot' && answer.badges && answer.badges.length > 0 && (
                  <span
                    className=""
                    style={{ fontSize: "13px", cursor: "pointer",marginRight:'.5rem' }}
                  >
                    {answer.badges.map((badge) => {
                      if (badge.name === "answered") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAnsweredBadge}
                          >
                            <span>🏅&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "quality") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipQualityBadge}
                          >
                            <span>🌟&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "amplified") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAmplifiedBadge}
                          >
                            <span>🏆&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                    })}
                  </span>
                )}
            </div>
          <div>
          {answer.expertScore && (
                  <span className="expScore">
                    <i className="fa fa-star" style={{ color: "#b4c6cc" }}></i>{" "}
                    {Math.round(answer.expertScore)}
                    <span style={{ color: "#949494" }}>/10</span>
                  </span>
                )}
          </div>
            </div>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap'}}>
            {answer.answeredTimestamp === answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>
                  {question.status === "accepted" ? "Viewed" : "Answered"}
                </span>
                <span className="datestamp">
                  {momentit(question.status === "accepted" ? question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp :answer.answeredTimestamp)}
                </span>
              </div>
            )}
            {answer.answeredTimestamp < answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>{question.status === "accepted" ? "Viewed" : "Last reviewed"}</span>
                <span className="datestamp">
                  {momentit(question.status === "accepted"?question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp:answer.lastUpdatedTimestamp)}
                </span>
              </div>
            )}
            </div>
            <div style={{display:'flex', justifyContent:'start'}}>
            {answer.internal && (
                <div
                className={styles.viewScore}
                >
                  <i className="fa fa-user-times"></i>&nbsp;Internal Only
                </div>
              )}
              {answer.privacy && (
                <span
                className={styles.viewScore}
                >
                  <i className="fa fa-lock"></i>&nbsp;Private Only
                </span>
              )}
            </div>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap'}}>
            {currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === '' && <span className={styles.viewScore}
                  style={{
                    color:`${answer.curationStatus ==='pending'?'grey':'green'}`,
                    paddingLeft:'0px'
                  }}>
              <svg width="18px" height="18px" viewBox="0 0 16 16" class="bi bi-bookmark-check-fill" fill="currentColor">
								<path fill-rule="evenodd" d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"></path>
							</svg>
              <span style={{color:'black'}}>
              {answer.curationStatus ==='pending'?'Pending':'Curated'}
              </span>
              </span>}
            </div>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap'}}>
            {answer.curationCategory && userState.geoAttributes.userId === answer.expertUuid && currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === 'pending' && <span 
                  style={{
                  }}>
                    <span style={{
                    borderRadius:'3px',
                    backgroundColor:`${answer.curationCategory === 1 ? 'red':answer.curationCategory === 2 ? 'orange':'green'}`,
                    color:'#fff',
                    fontSize:'10px',
                    padding:'4px',
                    fontWeight:'600',
                  }}>
                    Needs Curation-{curationStatus[answer.curationCategory-1]}
                    </span>
              </span>}
            </div>
          <div className="row">
            <div className={styles.userInfo}>
              <span className={styles.userName}>
                {/* {answer.expert.firstName} {answer.expert.lastName !== 'Bot' && answer.expert.lastName} */}
                {/* {answer.expert.lastName !== 'Bot' && answer.badges && answer.badges.length > 0 && (
                  <span
                    className="ms-2"
                    style={{ fontSize: "13px", cursor: "pointer" }}
                  >
                    {answer.badges.map((badge) => {
                      if (badge.name === "answered") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAnsweredBadge}
                          >
                            <span>🏅&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "quality") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipQualityBadge}
                          >
                            <span>🌟&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                      if (badge.name === "amplified") {
                        return (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltipAmplifiedBadge}
                          >
                            <span>🏆&nbsp;</span>
                          </OverlayTrigger>
                        );
                      }
                    })}
                  </span>
                )} */}
                {/* {answer.expertScore && (
                  <span className="expScore">
                    <i className="fa fa-star" style={{ color: "#b4c6cc" }}></i>{" "}
                    {Math.round(answer.expertScore)}
                    <span style={{ color: "#949494" }}>/10</span>
                  </span>
                )} */}
              </span>
              {/* {currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === '' && <span className={styles.viewScore}
                  style={{
                    float: "right",
                    marginRight:'-12px',
                    color:`${answer.curationStatus ==='pending'?'grey':'green'}`
                  }}>
              <svg width="18px" height="18px" viewBox="0 0 16 16" class="bi bi-bookmark-check-fill" fill="currentColor">
								<path fill-rule="evenodd" d="M4 0a2 2 0 0 0-2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4zm6.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"></path>
							</svg>
              </span>} */}
              {/* {answer.curationCategory && userState.geoAttributes.userId === answer.expertUuid && currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === 'pending' && <span className={styles.viewScore}
                  style={{
                    float: "right",                   
                  }}>
                    <span style={{
                    borderRadius:'3px',
                    backgroundColor:`${answer.curationCategory === 1 ? 'red':answer.curationCategory === 2 ? 'orange':'green'}`,
                    color:'#fff',
                    fontSize:'10px',
                    padding:'4px',
                    fontWeight:'600',
                  }}>
                    Needs Curation - {curationStatus[answer.curationCategory-1]}
                    </span>
              </span>} */}
              {/* {answer.internal && (
                <span
                className={styles.viewScore}
                  style={{
                    float: "right",
                  }}
                >
                  <i className="fa fa-user-times"></i>&nbsp;Internal Only
                </span>
              )} */}
              {/* {answer.privacy && (
                <span
                className={styles.viewScore}
                  style={{
                    float: "right",
                  }}
                >
                  <i className="fa fa-lock"></i>&nbsp;Private Only
                </span>
              )} */}
            </div>
          </div>
          {/* <div className="row">
            {answer.answeredTimestamp === answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>
                  {question.status === "accepted" ? "Viewed" : "Answered"}
                </span>
                <span className="datestamp">
                  {momentit(question.status === "accepted" ? question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp :answer.answeredTimestamp)}
                </span>
              </div>
            )}
            {answer.answeredTimestamp < answer.lastUpdatedTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="answeredBy" style={{paddingRight:'0px'}}>{question.status === "accepted" ? "Viewed" : "Last reviewed"}</span>
                <span className="datestamp">
                  {momentit(question.status === "accepted"?question.acceptedTimestamp === 0?question.postedTimestamp:question.acceptedTimestamp:answer.lastUpdatedTimestamp)}
                </span>
              </div>
            )}
          </div> */}
            </div>
            <div className={styles2.subcontainerMiddle} style={{backgroundColor:`${currentPath.pathname.includes('/search')?question.confidence?'green':'orange':'var(--light_color_shade)'}`}}></div>
            <div className={styles2.subcontainerRight}>
          {answer.attachments && answer.attachments.length > 0 &&
            answer.attachments[0].name.includes(".mp4") &&
            showHideVideo && (
              <div className="mt-2" style={{ textAlign: "center" }}>
                <video
                  width="80%"
                  height="400"
                  id={`${question.questionUuid}_${randomNumber}`}
                  controls
                  onBlur={()=>handlePauseAllVideo()}
                >
                  <source
                    src={`${answer.attachments[0].objectUrl}#t=${answer.startTime},${answer.endTime}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            )}
          {answer.attachments && answer.attachments.length > 0 &&
            answer.attachments[0].name.includes(".mp4") && (
              <div className="mt-2">
                <button
                  className={`btn btn-primary videoshowbuttonAB`}
                  onClick={() => toggleShowVideoButton()}
                >
                  {showHideVideo ? "Hide Video" : "Show Video"}
                </button>
              </div>
            )}
          <span className={styles.userScore}></span>
          {!answer.answerText.includes('vizsep') && <div className="row">
            {answer.answerText && answer.answerText.length >= 550 ? (
              <>
              <div
                className={`${styles.answerBlock} ${
                  isExpand ? "" : "hideAnswerText"
                }`}
                dangerouslySetInnerHTML={{
                  __html: replaceContentEditableText(answer.answerText),
                }}
              ></div>
              {
              question.docType==='Email'
              &&
              <div style={{
                textAlign: "end",
                color: "#4F6384",
                cursor: "pointer",
                fontSize: "12px",
              }} onClick={()=>setShowOrig(!isShowOrig)}>
                {!isShowOrig?'Show original email':'Hide original email'}&nbsp;{!isShowOrig? <i
                      className="fa fa-arrow-up"
                      style={{ cursor: "pointer" }}
                    ></i>: <i
                    className="fa fa-arrow-down"
                    style={{ cursor: "pointer" }}
                  ></i>}
              </div>}
              {isShowOrig &&question.docType==='Email' && answer.threads.map((thread, index) => {
                return (
                  <div
                    className="row me-2 mb-2"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="firstThreadLayout" style={{ width: "90%" }}>
                      <div className="innerThreadDiv">
                        <h4 className="firstReply">{thread}</h4>
                      </div>
                    </div>
                  </div>
                );
            })}
              </>
            ) : (
              <>
              <div
                className={`${styles.answerBlock}`}
                dangerouslySetInnerHTML={{
                  __html: replaceContentEditableText(answer.answerText),
                }}
              ></div>
              {
              question.docType==='Email'
              &&
              <div style={{
                textAlign: "end",
                color: "#4F6384",
                cursor: "pointer",
                fontSize: "12px",
              }} onClick={()=>setShowOrig(!isShowOrig)}>
                 {!isShowOrig?'Show original email':'Hide original email'}&nbsp;{!isShowOrig? <i
                      className="fa fa-arrow-down"
                      style={{ cursor: "pointer" }}
                    ></i>: <i
                    className="fa fa-arrow-up"
                    style={{ cursor: "pointer" }}
                  ></i>}
              </div>}
              {isShowOrig &&question.docType==='Email' && answer.threads.map((thread, index) => {
                return (
                  <div
                    className="row me-2 mb-2"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="firstThreadLayout" style={{ width: "90%" }}>
                      <div className="innerThreadDiv">
                        <h4 className="firstReply">{thread}</h4>
                      </div>
                    </div>
                  </div>
                );
            })}
              </>
            )}
          </div>}
          {answer.answerText.includes('vizsep') && <div
            className="row mt-4 me-2 mb-2"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <div className="firstThreadLayout" style={{ width: "95%" }}>
              <div
                className="innerThreadDiv"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h4 className="firstReply" style={{ width: "80%" }}>
                  {answer.answerText.split('vizsep') && answer.answerText.split('vizsep')[0]}
                </h4>
                {!isShowReply ? (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Show {answer.answerText && answer.answerText.split('vizsep').length - 1} Replies{" "}
                    <i
                      className="fa fa-arrow-down"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                ) : (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Hide Replies{" "}
                    <i
                      className="fa fa-arrow-up"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                )}
              </div>
              {answer.threadAttachmentsURL[0] && answer.threadAttachmentsURL[0].length > 0 && (
                <div style={{ textAlign: "center" }}>
                  <CarouselImage attachments={answer.threadAttachmentsURL[0]} />
                </div>
              )}
              <div style={{ display: "flex", flexWrap:'wrap' }}>
                {answer.threadAttachments &&
                  answer.threadAttachments[0].map((attachment) => {
                    return (
                      <div className="mt-3 mb-3 ms-3">
                        <AttachmentBox attachment={attachment} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          }
          {isShowReply && answer.answerText.includes('vizsep') && answer.answerText.split('vizsep').map((thread, index) => {
              if (index !== 0) {
                return (
                  <div
                    className="row me-2 mb-2"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="firstThreadLayout" style={{ width: "90%" }}>
                      <div className="innerThreadDiv">
                        <h4 className="firstReply">{thread}</h4>
                      </div>
                      {answer.threadAttachmentsURL[index].length > 0 && (
                        <div style={{ textAlign: "center" }}>
                          <CarouselImage
                            attachments={answer.threadAttachmentsURL[index]}
                          />
                        </div>
                      )}
                      <div style={{ display: "flex",flexWrap:'wrap' }}>
                        {answer.threadAttachments &&
                          answer.threadAttachments[index].map(
                            (attachment) => {
                              return (
                                <div className="mt-3 mb-3 ms-3">
                                  <AttachmentBox attachment={attachment} />
                                </div>
                              );
                            }
                          )}
                      </div>
                    </div>
                  </div>
                );
              }
            })}
          {!answer.answerText.includes('vizsep') &&  answer.answerText && answer.answerText.length >= 550 && (
            <div className={`${isExpand ? "" : "fader"}`}></div>
          )}
          {!answer.answerText.includes('vizsep') && answer.answerText && answer.answerText.length >= 550 && (
            <div className={`mb-2 mt-2 showmorediv`}>
              {isExpand ? (
                <span onClick={() => onChangeExpand(false)}>
                  <i
                    className="fa fa-angle-up"
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                  ></i>
                </span>
              ) : (
                <span
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => onChangeExpand(true)}
                >
                  <i
                    className="fa fa-angle-down"
                    style={{ fontWeight: "bold" }}
                  ></i>{" "}
                  show more
                </span>
              )}
            </div>
          )}
          {answer.attachmentURL && answer.attachmentURL.length > 0 && (
            <div className="mb-4">
              <CarouselImage attachments={answer.attachmentURL} />
            </div>
          )}
          {answer.url !== null && answer.url !== undefined && (
            <div className="mt-2" style={{ fontSize: "13px" }}>
              URL:{" "}
              <a
                href={answer.url}
                target="_blank"
                style={{ color: "var(--light_color_shade)", textDecoration:'none' }}
              >
                {answer.url}
              </a>
            </div>
          )}
          </div>
          </div>
          {/* dont change from here */}
          <div
            className={`${
              answer.attachments && answer.attachments.length > 0
                ? "mt-1"
                : null
            }`}
            style={{display:'flex', flexWrap:'wrap'}}
          >
            {answer.attachments &&
              answer.attachments.map((attachment) => {
                return (
                  <AttachmentBox
                    key={attachment.name}
                    attachment={attachment}
                  />
                );
              })}
          </div>
          {modalName !== "generativeREsponse" && <div style={{ display:'flex', flexWrap:'wrap', justifyContent:'space-between' }}>
          <div  style={{display:'flex', alignItems:'center'}}>
          <div>
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip>Number of times this answer was viewed</Tooltip>
                }
              >
                <span style={{ cursor: "pointer" }}>
                  <span className={styles.viewCount}>
                    {answer.popularityScore && <i className="fa fa-eye"></i>}
                  </span>
                  <span className={styles.viewScore}>
                    {answer.popularityScore}{" "}
                  </span>
                  &nbsp;
                </span>
              </OverlayTrigger>
            </div>
                
            </div>
            <div style={{display:'flex', alignItems:'center'}}>
           {question.docType !== 'Email' &&  <div>
                  {!question.reusableThreadQA && modalName !== "generativeREsponse" && !currentPath.pathname.includes('/shared') && !currentPath.pathname.includes('/editor') && !currentPath.pathname.includes('/favourite') && !currentPath.pathname.includes('/answered') && question.status !== "accepted" &&
                    !answer.userInitiatedCuration &&
                    answer.seekerCurationVisibility &&
                    answer.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                    (answer.curationCategory !== 1 ||
                      answer.curationStatus !== "pending") && (
                      <button
                        // className={`btn btn-primary videoshowbuttonAB mb-2`}
                        onClick={() => onClickRFU()}
                        style={{ marginTop: "8px", marginBottom:`${isDisabled? "10px":"0px"}` }}
                        disabled={isDisabled}
                        className={isDisabled ? styles2.disabledButton:`btn btn-primary videoshowbuttonAB mb-2`}
                      >
                        Request for Update
                      </button>
                    )}
                  {!question.reusableThreadQA &&  modalName !== "generativeREsponse" && !currentPath.pathname.includes('/editor')&& !currentPath.pathname.includes('/shared') && !currentPath.pathname.includes('/favourite') && !currentPath.pathname.includes('/answered') && question.status !== "accepted" &&
                    !answer.userInitiatedCuration &&
                    !answer.seekerCurationVisibility &&
                    answer.expert.userUuidStr !==
                      userState.geoAttributes.userId && (
                      <button
                        onClick={() => onClickRFU()}
                        style={{ marginTop: "8px", marginBottom:`${isDisabled? "10px":"0px"}` }}
                        disabled={isDisabled}
                        className={isDisabled ? styles2.disabledButton:`btn btn-primary videoshowbuttonAB mb-2`}
                      >
                        Request for Update
                      </button>
                    )}
                  {!question.reusableThreadQA && !currentPath.pathname.includes('/editor')&&  !currentPath.pathname.includes('/shared') && !currentPath.pathname.includes('/favourite') && !currentPath.pathname.includes('/answered') && question.status !== "accepted" &&
                    !answer.userInitiatedCuration &&
                    answer.seekerCurationVisibility &&
                    answer.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                    answer.curationCategory === 1 &&
                    answer.curationStatus === "pending" && (
                      <button
                        onClick={() => onClickRFU()}
                        style={{ marginTop: "8px", marginBottom:`${isDisabled? "10px":"0px"}` }}
                        disabled={isDisabled}
                        className={isDisabled ? styles2.disabledButton:`btn btn-primary videoshowbuttonABUrgent mb-2`}

                      >
                        Request for Update
                      </button>
                    )} 
                  {isRatingDone && !question.reusableThreadQA && CURRENT_ROLE === 'Seeker' && !currentPath.pathname.includes('/editor')&&  modalName !== "generativeREsponse" && !currentPath.pathname.includes('/shared') && !currentPath.pathname.includes('/favourite') && question.status !== "accepted" && domainState !== null &&
                    domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].rating === null && (domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback === null || domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].rating === '') &&  currentPath.pathname.includes('/answered') &&  (
                      <button
                        className={`btn btn-primary videoshowbuttonAB mb-2`}
                        style={{ marginTop: "8px" }} disabled={answer.userInitiatedCuration}
                        onClick={()=>onClickFU()}
                        
                      >
                        Request Follow-Up
                      </button>
                    )}
                </div>}
              {userState.geoAttributes.userId === answer.expertUuid && currentPath.pathname.includes('/expertHome/answered') && expertAnsweredState.curationStatus === 'pending' && <div style={{paddingRight:'5px', borderRight:'1px solid lightgrey'}}>
                <CurationButtons question={question} answer={answer}/>
              </div>}
                <div className={styles.helpfulButton}>
                  {isRatingDone && !currentPath.pathname.includes('/search/') &&  domainState !== null &&
                    domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && (
                      <div id={styles.btnHelpful}>
                        <Rating
                          helpful={helpfulAPIPayload}
                          id={answer.docId === undefined ?answer.origAnswerUuid:answer.docId}
                          rating={domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId]}
                          isDisable={
                            answer.expert.lastName === "Bot"
                              ? true
                              : undefined
                          }
                        />
                      </div>
                    )}
                    {question.docType !== 'Email' && currentPath.pathname.includes('/search/') && (
                      <div id={styles.btnHelpful}>
                        <Voting
                          helpful={helpfulAPIPayload}
                          answer = {answer}
                        />
                      </div>
                    )}
                </div>
            </div>
          </div>}
          { isRatingDone && CURRENT_ROLE === 'Seeker' && question.status !== "accepted" && domainState !== null && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].rating !== null &&(domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback === null || domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback === '') && currentPath.pathname.includes('/answered') && <div className="mt-3">
          <FeedbackWindow answerUuid={answer.origAnswerUuid} />
          </div>}
          {isRatingDone && CURRENT_ROLE === 'Seeker' && question.status !== "accepted" && domainState !== null && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].rating !== null && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback !== null && domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback !== '' && currentPath.pathname.includes('/answered') && <div className=" feedbackDiv">
          Feedback : <span style={{fontStyle: 'italic',fontSize: '12px',color: 'rgb(102, 102, 102'}}>{domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId].feedback}</span>
          </div>}
        </div>
      </div>
    </div>
    </InView>
  );
}


